import { sqTableRuntimeStore } from '@/core/core.stores';
import { freezeOutsideProduction } from '@/core/immutability.utilities';
import type { ITEM_TYPES } from '@/trendData/trendData.constants';

/**
 * Overlays the fetched results onto a table so readers see them alongside its config. Tables with
 * no entry are returned as-is (identity preserved).
 */
export function withTableValues<T extends { id: string; itemType: ITEM_TYPES.TABLE }>(item: T): T {
  const values = sqTableRuntimeStore.getState().values[item.id];
  return values ? freezeOutsideProduction({ ...item, ...values }) : item;
}
